function getParam(name) {
    var url = window.location.href;
    var urlOne = url.split('#')[1];
    var urlParam = urlOne.split('?')[1];
    if (urlParam) {
        var paramArr = urlParam.split('&');
        var param = {};
        for (var i = 0; i < paramArr.length; i++) {
            param[paramArr[i].split('=')[0]] = paramArr[i].split('=')[1]
        }
        if (param[name]) {
            return param[name];
        }
    }
    return '';
}

function getPageParamStr(page, pageSize) {
    return "&page=" + page + "&rows=" + pageSize
}


function formatMoney(value) {
    if (value == null || isNaN(value)) return String(value);
    const sign = value < 0 ? '-' : '';
    const abs = Math.abs(value);
    const W = 10000;        // 万
    const Y = 100000000;    // 亿
    // 小于 1 万，直接返回
    if (abs < W) return sign + abs.toString();
    // 大于等于 1 亿：显示 “X亿[零]Y万”
    if (abs >= Y) {
        const yi = Math.floor(abs / Y);
        const wan = Math.floor((abs % Y) / W); // 只取到“万”为止

        if (wan === 0) {
            return sign + yi + '亿';
        }
        // wan < 1000 代表没有“千万位”，需要补一个“零”
        const needLing = wan < 1000;
        return sign + yi + '亿' + (needLing ? '零' : '') + wan + '万';
    }
    // 1 万 ~ 1 亿：保留一位小数，去掉尾部 .0
    const textWan = (abs / W).toFixed(1).replace(/\.0$/, '');
    return sign + textWan + '万';
}


function getRandomColor() {
    // 生成RGB值在100到200之间的颜色，避免颜色太亮或太暗
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    // 转换为十六进制格式
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}


export {
    getParam, getPageParamStr, formatMoney, getRandomColor
}
